import { Box } from '@mui/material';

import type { BoxProps } from '@mui/material';
import type { FC } from 'react';

export const FlexibleWrapper: FC<BoxProps> = ({ sx, ...props }) => (
  <Box
    sx={{
      flexShrink: 1,
      flexGrow: 1,
      display: 'grid',
      ...sx,
    }}
    {...props}
  />
);
